import { QuizBuilderStep } from '../../../common/QuizBuilder/QuizBuilderStep';
import './styles.css';

export default QuizBuilderStep;
